import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './inputElement.module.scss';

const InputElement = ({
  name,
  type,
  onChange,
  value,
  invalid,
  style,
  ...rest
}) => {
  return (
    <input
      className={cn(styles.input, invalid && styles.invalid)}
      style={style}
      name={name}
      type={type}
      onChange={onChange}
      value={value || ''}
      {...rest}
    />
  );
};

InputElement.defaultProps = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
};

export default InputElement;
